import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useCreateEnterpriseTemplateFromProjectPlanCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	projectPlanId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	strategyId?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _projectPlanId = isRef<string>(projectPlanId) ? projectPlanId : ref<string>((typeof projectPlanId === 'function') ? projectPlanId() : projectPlanId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		id: _id,
		strategyId: _strategyId,
		name: _name,
		description: _description,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof projectPlanId === 'function') { _projectPlanId.value = projectPlanId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }

			return new c.CreateEnterpriseTemplateFromProjectPlanCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _projectPlanId.value, _id.value, _strategyId.value, _name.value, _description.value)
		})
	}

	return {
		...result,
		authorizedCreateEnterpriseTemplateFromProjectPlanCommandV1: result.authorized,
		createEnterpriseTemplateFromProjectPlanCommandV1: result.command,
		completedCreateEnterpriseTemplateFromProjectPlanCommandV1: result.completed,
		errorCreateEnterpriseTemplateFromProjectPlanCommandV1: result.error,
		invokeCreateEnterpriseTemplateFromProjectPlanCommandV1: result.invoke,
		invokingCreateEnterpriseTemplateFromProjectPlanCommandV1: result.invoking,
		succeedCreateEnterpriseTemplateFromProjectPlanCommandV1: result.succeed,
		validationErrorsCreateEnterpriseTemplateFromProjectPlanCommandV1: result.validationErrors,
		onSucceedCreateEnterpriseTemplateFromProjectPlanCommandV1: result.onSucceed,
	}
}

export function useCreateProjectPlanTemplateCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	durationInMonths?: number | Ref<number> | (() => number), 
	granularity?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _durationInMonths = isRef<number>(durationInMonths) ? durationInMonths : ref<number>((typeof durationInMonths === 'function') ? durationInMonths() : durationInMonths)
	const _granularity = isRef<any>(granularity) ? granularity : ref<any>((typeof granularity === 'function') ? granularity() : granularity)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		durationInMonths: _durationInMonths,
		granularity: _granularity,
		denomination: _denomination,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof durationInMonths === 'function') { _durationInMonths.value = durationInMonths() }
			if (typeof granularity === 'function') { _granularity.value = granularity() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }

			return new c.CreateProjectPlanTemplateCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _durationInMonths.value, _granularity.value, _denomination.value)
		})
	}

	return {
		...result,
		authorizedCreateProjectPlanTemplateCommandV1: result.authorized,
		createProjectPlanTemplateCommandV1: result.command,
		completedCreateProjectPlanTemplateCommandV1: result.completed,
		errorCreateProjectPlanTemplateCommandV1: result.error,
		invokeCreateProjectPlanTemplateCommandV1: result.invoke,
		invokingCreateProjectPlanTemplateCommandV1: result.invoking,
		succeedCreateProjectPlanTemplateCommandV1: result.succeed,
		validationErrorsCreateProjectPlanTemplateCommandV1: result.validationErrors,
		onSucceedCreateProjectPlanTemplateCommandV1: result.onSucceed,
	}
}

export function useDeleteProjectPlanTemplateCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeleteProjectPlanTemplateCommandV1(_workspaceId.value, _strategyId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeleteProjectPlanTemplateCommandV1: result.authorized,
		deleteProjectPlanTemplateCommandV1: result.command,
		completedDeleteProjectPlanTemplateCommandV1: result.completed,
		errorDeleteProjectPlanTemplateCommandV1: result.error,
		invokeDeleteProjectPlanTemplateCommandV1: result.invoke,
		invokingDeleteProjectPlanTemplateCommandV1: result.invoking,
		succeedDeleteProjectPlanTemplateCommandV1: result.succeed,
		validationErrorsDeleteProjectPlanTemplateCommandV1: result.validationErrors,
		onSucceedDeleteProjectPlanTemplateCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectPlanTemplateCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	durationInMonths?: number | Ref<number> | (() => number), 
	granularity?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _durationInMonths = isRef<number>(durationInMonths) ? durationInMonths : ref<number>((typeof durationInMonths === 'function') ? durationInMonths() : durationInMonths)
	const _granularity = isRef<any>(granularity) ? granularity : ref<any>((typeof granularity === 'function') ? granularity() : granularity)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		durationInMonths: _durationInMonths,
		granularity: _granularity,
		denomination: _denomination,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof durationInMonths === 'function') { _durationInMonths.value = durationInMonths() }
			if (typeof granularity === 'function') { _granularity.value = granularity() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }

			return new c.UpdateProjectPlanTemplateCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _durationInMonths.value, _granularity.value, _denomination.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectPlanTemplateCommandV1: result.authorized,
		updateProjectPlanTemplateCommandV1: result.command,
		completedUpdateProjectPlanTemplateCommandV1: result.completed,
		errorUpdateProjectPlanTemplateCommandV1: result.error,
		invokeUpdateProjectPlanTemplateCommandV1: result.invoke,
		invokingUpdateProjectPlanTemplateCommandV1: result.invoking,
		succeedUpdateProjectPlanTemplateCommandV1: result.succeed,
		validationErrorsUpdateProjectPlanTemplateCommandV1: result.validationErrors,
		onSucceedUpdateProjectPlanTemplateCommandV1: result.onSucceed,
	}
}

